import * as utils from '../utils';
import * as constants from '../commons/constants';
import type { RunnerOptions } from '../runOptions';
import type { TestRunStatusTestResult } from '../testRunStatus';


export const isFailedTest = (testResult: TestRunStatusTestResult) => {
    const { status, mobile } = testResult;
    if (mobile?.isAppFromDevice || mobile?.isAppForIosVirtualDevice) {
        return false;
    }
    return status === constants.runnerTestStatus.FAILED;
};

export const isAbortedTest = (testResult: TestRunStatusTestResult) => {
    const { status } = testResult;
    return status === constants.runnerTestStatus.ABORTED;
};

export const isPassedTest = (testResult: TestRunStatusTestResult) => {
    const { status } = testResult;
    return status === constants.runnerTestStatus.PASSED;
};

export const isSkippedTest = (testResult: TestRunStatusTestResult) => testResult.runnerStatus === constants.runnerStatus.SKIPPED;
export const isEvaluatingTest = (testResult: TestRunStatusTestResult) => testResult.testStatus === constants.testStatus.EVALUATING;

interface TestResultsObj { [resultId: string]: TestRunStatusTestResult }

export const getSkippedCount = (testResults: TestResultsObj, options: RunnerOptions) => Object.values(testResults).filter(testResult =>
    (isSkippedTest(testResult) &&
    (utils.isQuarantineAndNotRemoteRun(testResult, options) || testResult.mobile?.isAppFromDevice || testResult.mobile?.isAppForIosVirtualDevice)),
).length;

export const getFailureEvaluatingCount = (testResults: TestResultsObj) =>
    Object.values(testResults).filter((testResult) => isFailedTest(testResult) && isEvaluatingTest(testResult)).length;

export const getFailedTests = (testResults: TestResultsObj) => Object.values(testResults).filter(isFailedTest);

export const getPassedTests = (testResults: TestResultsObj) => Object.values(testResults).filter(isPassedTest);

export const getAbortedTests = (testResults: TestResultsObj) => Object.values(testResults).filter(isAbortedTest);
